<template>
    <div id="permissionManagement">
      <el-container>
        <el-aside width="200px">

          <el-row >
            <el-col :span="24">
              <el-menu default-active="2">

                <el-menu-item v-for="menu in menuList" :key="menu.id" :index="''+menu.id">
                  <i class="el-icon-document"></i>
                  <span slot="title">{{menu.label}}</span>

                </el-menu-item>

              </el-menu>
            </el-col>
          </el-row>
        </el-aside>
      <el-container>
        <el-header>角色管理</el-header>

        <!-- 内容区-->
        <el-main>
          <el-row class="tac">
            <el-col :span="4">
              <el-menu
                default-active="2"
                class="el-menu-vertical-demo">
                <el-button @click="initRolePopForm(1)" size="medium"  class="myButton">添加角色</el-button>
                <el-menu-item v-for="(roleInfo, index) in roleInfoList" :key="roleInfo.id"  :index="''+roleInfo.id">
                  <!-- <i class="el-icon-setting"></i> -->

                  <!-- <template slot="title">{{roleInfo.roleName}}</template> -->

                  <span @click="getRolePermission(roleInfo.id)">{{roleInfo.roleName}}</span>

                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="el-icon-more el-icon-left"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item >
                        <span @click="initRolePopForm(2, index)">修改角色名称</span>
                        </el-dropdown-item>
                      <el-dropdown-item command="b">

                        <span @click="deleteRole(roleInfo.id)">删除角色</span>
                      </el-dropdown-item>

                    </el-dropdown-menu>
                  </el-dropdown>

                </el-menu-item>
              </el-menu>
            </el-col>

            <el-col :span="18">

              <el-tabs v-model="platform" @tab-click="handleTabClick">
                <el-tab-pane label="移动端" name="APP"></el-tab-pane>
                <el-tab-pane label="PC端" name="PC"></el-tab-pane>
                <el-tab-pane label="PAD" name="PAD"></el-tab-pane>

              </el-tabs>

              <el-tree
                :data="roleTree"
                show-checkbox
                node-key="id"
                ref="tree"
                highlight-current
                :props="defaultProps"
                :check-strictly="true"
                :default-expand-all="true"
                :default-checked-keys="checkedRoles">
              </el-tree>
            </el-col>
        </el-row>
          <el-button @click="updateRolePermission" class="save" type="primary">保存</el-button>
        </el-main>
      </el-container>
    </el-container>

    <!-- Form -->
    <el-dialog :title="dialogInfo.title" :visible.sync="dialogInfo.show">
      <!-- <el-form>
        <el-form-item label="角色名称" :label-width="formLabelWidth"> -->

          角色名称<el-input v-model="role.roleName" autocomplete="off"></el-input>
          角色编码<el-input v-model="role.roleCode" autocomplete="off"></el-input>

        <!-- </el-form-item>
      </el-form> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="hideDialog">取 消</el-button>
        <el-button type="primary" @click="submitRoleInfo">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/modules/api.js'

export default {
  name: 'permissionManagement',
  data () {
    return {
      // 一级菜单
      menuList: [],
      // 所有角色
      roleInfoList: [],
      // 权限树
      roleTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 所有菜单
      allTreeNodes: [],
      // 用户可用菜单
      checkedRoles: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      // 角色更新vo
      role: {
        id: '',
        roleName: '',
        roleCode: ''
      },
      dialogInfo: {
        type: '',
        title: '',
        show: false
      },
      // 角色权限更新请求vo
      rolePermisionUpdateVo: {
        platform: '',
        roleId: '',
        permissionIds: []
      },
      // 角色权限查询vo
      rolePermissionReqVo: {
        platform: '',
        roleId: ''
      },
      platform: 'APP',
      tempRoleId: ''

    }
  },
  mounted () {
    this.getUserRoleList()

    var menu1 = {id: 1, label: '权限管理'}
    var menu2 = {id: 2, label: '角色管理'}
    this.menuList.push(menu1)
    this.menuList.push(menu2)
  },

  methods: {
    handleTabClick (tab, event) {
      console.log(tab.name)
    },

    // 获取选择的节点
    getCheckedNodes () {
      console.log(this.$refs.tree.getCheckedNodes())
      console.log(this.$refs.tree.getCheckedKeys())
    },
    handleCommand (command) {
      this.$message('click on item ' + command)
    },
    // 初始化角色弹出框
    initRolePopForm (type, index) {
      this.dialogInfo.show = true
      this.dialogInfo.type = type

      if (this.dialogInfo.type == 1) {
        this.dialogInfo.title = '添加角色'
      } else {
        this.dialogInfo.title = '修改角色'
      }
      this.role = JSON.parse(JSON.stringify(this.roleInfoList[index]))
    },
    // 隐藏
    hideDialog () {
      this.dialogInfo.show = false
    },

    // 获取用户角色
    getUserRoleList () {
      var that = this
      api.getRoleList({}, function (res) {
        that.roleInfoList = res.data
      })
    },
    // 保存/修改角色
    submitRoleInfo (type) {
      this.hideDialog()

      console.log(this.role)
      var that = this
      api.saveRoleInfo(this.role, function (res) {
        that.refreshPage()
      })
    },
    // 刪除角色
    deleteRole (roleId) {
      this.role.id = roleId
      var that = this
      api.deleteRoleInfo(this.role, function (res) {
        that.refreshPage()
      })
    },
    // 获取角色权限
    getRolePermission (roleId) {
      if (roleId == null | roleId == '') {
        roleId = this.tempRoleId
      } else {
        this.tempRoleId = roleId
      }

      var that = this
      this.rolePermissionReqVo.roleId = roleId
      this.rolePermissionReqVo.platform = this.platform

      api.getRolePermission(this.rolePermissionReqVo, function (res) {
        that.roleTree = res.data.allTreeNodes
        that.checkedRoles = res.data.roleTreeNodes
      })
    },

    // 更新角色权限信息
    updateRolePermission () {
      this.rolePermisionUpdateVo.roleId = this.rolePermissionReqVo.roleId
      this.rolePermisionUpdateVo.platform = this.platform
      this.checkedRoles = this.$refs.tree.getCheckedKeys()
      this.rolePermisionUpdateVo.permissionIds = this.checkedRoles

      var that = this
      api.saveRolePermission(this.rolePermisionUpdateVo, function (res) {
        that.refreshPage()
      })
    },
    refreshPage () {
      location.reload()
      // this.$router.go(0)
    }

  },
  watch: {
    platform: {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(this.platform)
        this.getRolePermission(this.tempRoleId)
      }
    }
  }
}
</script>

<style scoped>
  #permissionManagement {
    margin : 0;
    padding: 0;
    background:#f5f5f5;
    padding:60px 20px 10px;
  }
  #permissionManagement >>> .el-menu{
    min-height:  300px;
    background: #ffffff;
  }
  #permissionManagement >>> .el-tabs__nav-scroll{
    line-height: 50px;
  }
  #permissionManagement >>> .el-tree__empty-block{
    min-height: 400px
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .save{
    width:200px;
    margin:0;
  }
 .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

.container{
    margin-top:100px;
    margin-left: 10px;
    margin-bottom: 100px;
}
.title{
    margin-bottom: 40px;
}
.input{
    padding-left:0px;
}
.btn_div{
    width:90%;
    margin: 0 auto;
}
.check_btn{
    width: 100%;
    background: #EBEBEB;
    border: none;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/permission/permissionManagement.vue